import React, { useState, useEffect } from 'react';
import AvatarDropdown from './AvatarDropdown';
import SidebarMoreMenu from './SidebarMoreMenu';
import { getNextTier } from '../../lib/planLimits';

const ICONS = {
  home:    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11.5 12 4l9 7.5"/><path d="M5 10v9a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1v-9"/></svg>,
  explore: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76" fill="currentColor" fillOpacity="0.3"/></svg>,
  search:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>,
  create:  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0"/><line x1="12" y1="18" x2="12" y2="22"/></svg>,
  clips:   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="3"/><polygon points="10 9 15 12 10 15 10 9" fill="currentColor" stroke="none"/></svg>,
  profile: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="3.5"/><path d="M4 21c0-4.4 3.6-7 8-7s8 2.6 8 7"/></svg>,
  library: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M12 6.5C10.5 5.4 8.4 4.8 6 4.8c-1.2 0-2.3.1-3 .3v13c.7-.2 1.8-.3 3-.3 2.4 0 4.5.6 6 1.7"/><path d="M12 6.5c1.5-1.1 3.6-1.7 6-1.7 1.2 0 2.3.1 3 .3v13c-.7-.2-1.8-.3-3-.3-2.4 0-4.5.6-6 1.7z"/><path d="M12 6.5v13"/></svg>,
  inbox:   <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>,
  // Bell — Notifications nav item. Opens the slide-out panel (which
  // still hosts the Notifications + Activity tabs).
  notifications: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"/><path d="M13.73 21a2 2 0 0 1-3.46 0"/></svg>,
  // Single-person icon — matches the PDF's Guesting glyph.
  collabs: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="3.5"/><path d="M5 20c0-3.9 3.1-6.5 7-6.5s7 2.6 7 6.5"/></svg>,
  /* Earn icon (#39) — circle with a dollar sign. Reads "make money"
     more clearly than the previous handshake/heart hybrid. */
  partners:<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M14.8 9.5a2.5 2.5 0 0 0-2.3-1.5h-1a2.2 2.2 0 0 0 0 4.4h1a2.2 2.2 0 0 1 0 4.4h-1A2.5 2.5 0 0 1 9.2 15.5"/><line x1="12" y1="6.5" x2="12" y2="8"/><line x1="12" y1="16" x2="12" y2="17.5"/></svg>,
  collapse:<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>,
  // Grow — upward trend. Groups the audience/network-growth destinations.
  grow:    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 17 9 11 13 15 21 7"/><polyline points="15 7 21 7 21 13"/></svg>,
  // Earn — coins. Groups sponsorship / monetization destinations.
  earn:    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><ellipse cx="12" cy="6" rx="8" ry="3"/><path d="M4 6v6c0 1.7 3.6 3 8 3s8-1.3 8-3V6"/><path d="M4 12v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6"/></svg>,
  // Chevron for expand/collapse of a nav group.
  chev:    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>,
  // Matches — infinity / linked-loops glyph, per the PDF.
  matches: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M9.828 9.172a4 4 0 1 0 0 5.656 10 10 0 0 0 2.172-2.828 10 10 0 0 1 2.172-2.828 4 4 0 1 1 0 5.656 10 10 0 0 1-2.172-2.828 10 10 0 0 0-2.172-2.828"/></svg>,
};

/* Final nav rail. "Notifications" was previously a bell chip in the
   brand row + a slide-out — promoted to a real menu item with an
   unread-count badge so it carries the same weight as the other
   destinations and users see the count without hovering the brand. */
/* Rail IA. Leaf items sit at the top; the growth + monetization
   destinations are grouped under collapsible "Grow" and "Earn" headers so
   the two reasons people are here — grow your show, earn from it — read as
   first-class. Matching + guesting live under Grow (that's where you find
   collaborators + guest swaps); sponsorships under Earn. */
const NAV_MAIN = [
  { id: 'home',        label: 'Home'        },
  { id: 'create',      label: 'Create'      },
  { id: 'collaborate', label: 'Collaborate', icon: 'collabs' },
  { id: 'grow',        label: 'Grow'        },
  { id: 'monetize',    label: 'Monetize',    icon: 'earn' },
];

// Guests get a networking-focused rail — Home + Collaborate + Grow. Host-only
// surfaces (Create, Monetize) are hidden: guests don't make episodes or take
// sponsor deals, they're here to get discovered and booked. Library, Clips,
// and Matches live one level down in the "More" menu now that the rail is
// five flat destinations — see SidebarMoreMenu.
const GUEST_HIDDEN_NAV = new Set(['create', 'monetize']);
function navForAccountType(accountType) {
  if (accountType !== 'guest') return NAV_MAIN;
  return NAV_MAIN.filter((item) => !GUEST_HIDDEN_NAV.has(item.id));
}

/** Maps sidebar id -> view name used by the internal router. */
function viewFor(id) {
  switch (id) {
    case 'home':        return 'shows';
    case 'explore':     return 'explore';
    case 'search':      return 'search';
    case 'create':      return 'builder';
    case 'clips':       return 'clips';
    case 'profile':     return 'profile';
    case 'library':     return 'episodes';
    case 'matches':     return 'matches';
    case 'collabs':     return 'collabs';
    case 'collaborate': return 'collabs';
    case 'grow':        return 'explore';
    case 'inbox':       return 'inbox';
    case 'partners':    return 'partners';
    case 'monetize':    return 'partners';
    default:            return null;
  }
}

const COLLAPSE_KEY = 'sidebar-collapsed';

export default function WorkspaceSidebar({
  user, profile, view, onNavigate, onSignOut, onOpenAuth,
  shows = [], activeShowId, onSelectShow, onManageShows,
  canCreateShow = true, onCreateShow,
  inboxCount = 0,
  notifCount = 0,
  onOpenNotifications,
}) {
  const [collapsed, setCollapsed] = useState(() => {
    try { return localStorage.getItem(COLLAPSE_KEY) === 'true'; } catch { return false; }
  });
  // Hover-peek: on every page EXCEPT home the rail sits collapsed (icons only)
  // and expands over the content when the pointer rolls onto it — Instagram
  // style. Home keeps the user's manual collapse preference.
  const [hovered, setHovered] = useState(false);

  // Mobile: the rail is an off-canvas drawer opened by the hamburger. There's
  // no hover there, so the collapse/peek logic (which is desktop hover-driven)
  // would otherwise render the drawer as icons-only with the Grow/Earn groups
  // unopenable. Force the full, expanded menu whenever we're at drawer width.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches
  );
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mq = window.matchMedia('(max-width: 768px)');
    const onChange = () => setIsMobile(mq.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  // The rail stays open on every page; it only collapses when the user
  // manually closes it (persisted). Home is the exception — it always opens
  // fully expanded (wordmark, labels, active-show + profile card) regardless
  // of a stale collapse preference from another page, since that's the
  // intended first-look experience for the Home Redesign.
  const isHomeView = view === 'shows' || view === 'dashboard';
  const baseCollapsed = !isMobile && collapsed && !isHomeView;
  const expanded = isMobile || !baseCollapsed || hovered;    // mobile drawer is always full; desktop hover peeks a manually-collapsed rail
  const peek = !isMobile && hovered && baseCollapsed;        // overlay mode (desktop only; doesn't reflow)

  // Persist the user's manual preference.
  useEffect(() => {
    try { localStorage.setItem(COLLAPSE_KEY, String(collapsed)); } catch {}
  }, [collapsed]);

  // Broadcast the effective rail width to the layout grid. Hover-peek is an
  // overlay, so the grid stays at the collapsed width — content never shifts.
  useEffect(() => {
    window.dispatchEvent(new CustomEvent('ws:sidebar-collapse', { detail: baseCollapsed }));
  }, [baseCollapsed]);

  // Apply persisted theme on mount (default 'dark').
  useEffect(() => {
    try {
      const saved = localStorage.getItem('theme') || 'dark';
      document.documentElement.dataset.theme = saved;
    } catch {
      document.documentElement.dataset.theme = 'dark';
    }
  }, []);

  // Next tier up for this user (free → Creator → Studio → Network).
  // null when they're already on the top tier — the upgrade pill hides.
  const nextTier = getNextTier(profile?.plan);

  function resolveActiveId() {
    if (view === 'shows' || view === 'dashboard')         return 'home';
    if (view === 'search')                                 return 'search';
    if (view === 'builder' ||
        view === 'editor' || view === 'brief' ||
        view === 'thinking' || view === 'results')        return 'create';
    if (view === 'clips' || view === 'clip-upload')        return 'clips';
    if (view === 'profile' ||
        view === 'guest-profile' ||
        view === 'guest-profile-edit')                    return 'profile';
    if (view === 'episodes' || view === 'library')         return 'library';
    if (view === 'collabs')                                return 'collaborate';
    if (view === 'explore' || view === 'matches')           return 'grow';
    if (view === 'inbox' || view === 'notifications')      return 'inbox';
    if (view === 'partners' || view === 'marketplace')     return 'monetize';
    return null;
  }
  const activeId = resolveActiveId();

  const activeShow = shows.find((s) => s.id === activeShowId) || shows[0] || null;

  function handleNavClick(item) {
    // Notifications doesn't navigate — it opens the slide-out panel
    // (which carries the Notifications + Activity tabs).
    if (item.action === 'openNotifications') {
      if (!user) { onOpenAuth?.('signup'); return; }
      onOpenNotifications?.();
      return;
    }
    const v = viewFor(item.id);
    if (!v) return;
    // A signed-out guest only has the builder unlocked. Every other rail
    // destination prompts sign-up rather than bouncing them to landing.
    if (!user && v !== 'builder') { onOpenAuth?.('signup'); return; }
    onNavigate?.(v);
  }

  function renderNavItem(item, { sub = false } = {}) {
    const isActive = activeId === item.id;
    return (
      <button
        key={item.id}
        type="button"
        className={`ws-nav-item${sub ? ' ws-nav-subitem' : ''}${isActive ? ' ws-nav-item-active' : ''}`}
        onClick={() => handleNavClick(item)}
        title={!expanded ? item.label : undefined}
        aria-current={isActive ? 'page' : undefined}
      >
        <span className="ws-nav-accent" aria-hidden="true" />
        <span className="ws-nav-icon">{ICONS[item.icon || item.id]}</span>
        {expanded && <span className="ws-nav-label">{item.label}</span>}
        {expanded && item.id === 'inbox' && inboxCount > 0 && (
          <span className="ws-nav-count">{inboxCount > 9 ? '9+' : inboxCount}</span>
        )}
        {expanded && item.id === 'notifications' && notifCount > 0 && (
          <span className="ws-nav-count">{notifCount > 9 ? '9+' : notifCount}</span>
        )}
        {/* Collapsed state — show a small unread dot beside the icon so
            users still see "you have something" without needing the
            number. Applies to notifications + inbox. */}
        {!expanded && (
          (item.id === 'notifications' && notifCount > 0) ||
          (item.id === 'inbox' && inboxCount > 0)
        ) && (
          <span className="ws-nav-dot" aria-hidden />
        )}
        {expanded && item.badge && (
          <span className={`ws-nav-badge${item.badgeColor ? ` ws-nav-badge--${item.badgeColor}` : ''}`}>
            {item.badge}
          </span>
        )}
      </button>
    );
  }

  return (
    <aside
      className={`ws-sidebar${!expanded ? ' ws-sidebar--collapsed' : ''}${peek ? ' ws-sidebar--peek' : ''}`}
      onMouseEnter={() => { if (baseCollapsed) setHovered(true); }}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Brand + collapse toggle. Bell removed — Notifications is a
          first-class menu item in NAV_MAIN now. The manual collapse toggle
          only shows on Home; elsewhere the rail auto-collapses + hover-peeks. */}
      <div className="ws-brand">
        {expanded && (
          /* Lowercase epio. wordmark — same mark as the landing page:
             white text with a yellow signature period. */
          <span className="ws-brand-text ws-brand-text--lc">
            epio<span className="ws-brand-dot">.</span>
          </span>
        )}
        {/* Home always renders expanded (see isHomeView above), so the
            manual collapse toggle has nothing to do there — hidden rather
            than shown as a dead control. */}
        {!isHomeView && (
          <button
            type="button"
            className={`ws-collapse-toggle${!expanded ? ' ws-collapse-toggle--collapsed' : ''}`}
            onClick={() => setCollapsed(v => !v)}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {ICONS.collapse}
          </button>
        )}
      </div>

      {/* Primary nav rail */}
      <nav className="ws-nav">
        {navForAccountType(profile?.account_type).map((item) => renderNavItem(item))}
      </nav>

      <div className="ws-nav-spacer" />

      {/* Active-show card — sits just above the profile row, per the Home
          Redesign. Self-hides for guests / accounts with no shows yet. */}
      {user && expanded && activeShow && (
        <button
          type="button"
          className="ws-activeshow"
          onClick={() => onManageShows?.()}
          title={activeShow.title || 'Your show'}
        >
          <span className="ws-activeshow-thumb" aria-hidden>
            {(activeShow.title || 'S').trim().charAt(0).toUpperCase()}
          </span>
          <span className="ws-activeshow-meta">
            <span className="ws-activeshow-name">{activeShow.title || 'Your show'}</span>
            <span className="ws-activeshow-status"><i aria-hidden /> Active</span>
          </span>
        </button>
      )}

      {/* Avatar pill + dropdown — for a signed-out guest the workspace
          still renders (the builder is open to everyone), so this slot
          becomes the sign-in / join CTA instead. */}
      {user ? (
        <AvatarDropdown
          user={user}
          profile={profile}
          collapsed={!expanded}
          onNavigate={onNavigate}
          onSignOut={onSignOut}
          shows={shows}
          activeShowId={activeShowId}
          onSelectShow={onSelectShow}
          onManageShows={onManageShows}
          canCreateShow={canCreateShow}
          onCreateShow={onCreateShow}
        />
      ) : !expanded ? (
        <button
          type="button"
          className="ws-guest-auth-mini"
          title="Sign in"
          aria-label="Sign in"
          onClick={() => onOpenAuth?.('signin')}
        >
          {ICONS.profile}
        </button>
      ) : (
        <div className="ws-guest-auth">
          <button
            type="button"
            className="ws-guest-auth-join"
            onClick={() => onOpenAuth?.('signup')}
          >
            Join free
          </button>
          <button
            type="button"
            className="ws-guest-auth-signin"
            onClick={() => onOpenAuth?.('signin')}
          >
            Sign in
          </button>
        </div>
      )}

      {/* Upgrade pill — rounded outline, sits just under the profile
          dropdown. Label tracks the user's next tier (Creator / Studio /
          Network); hidden for top-tier users + signed-out guests. Routes
          into the subscription / upgrade flow. */}
      {user && expanded && nextTier && (
        <button
          type="button"
          className="ws-upgrade-pill"
          onClick={() => onNavigate?.('subscription')}
          title={`Upgrade to ${nextTier.label}`}
        >
          Upgrade to {nextTier.label}
        </button>
      )}

      {/* More — Library, Clips, Matches, and the settings/legal popover.
          Its content (which flies upward from here) hosts the destinations
          that don't earn a top-level slot in the flattened 5-item rail. */}
      <SidebarMoreMenu onNavigate={onNavigate} collapsed={!expanded} />

      {/* Help — anchored at the very bottom of the rail, under the
          credits block + More. Always one click away. */}
      <button
        type="button"
        className="ws-help-btn"
        onClick={() => onNavigate?.('help')}
        title="Help & support"
      >
        <span className="ws-help-btn-icon" aria-hidden>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </span>
        {expanded && <span>Help &amp; support</span>}
      </button>
    </aside>
  );
}
